// extracted by mini-css-extract-plugin
export default {"noAccess":"noAccess__JJQ3G","noAccess__list":"noAccess__list__vUnrs","noAccess__list__item":"noAccess__list__item__M5zpQ"};